import { AxCounterWithInput } from "../../Components/AxInput/AxCounterWithInput";
import { AxInit, ModuleName } from "../../Lib/AxSystem/AxInit";
import { AxProgressBar } from "../../Limestone/AxProgressBar/AxProgressBar";
import { ProgressBar } from "./ProgressbarGiftCards";
import Swal from 'sweetalert2';
import EXIF from "exif-js";
import { RequestHelper } from "../../Lib/Helper/RequestHelper";
import { ComponentFunction } from "@glidejs/glide";
import Glide from "@glidejs/glide";
import { I18nHelper, Translations } from "../../Lib/Helper/I18nHelper";
import { Asset } from "../../Interfaces/Assets/Asset";
import { AxLimeStone } from "../../Limestone/AxLimeStone";
import tippy from 'tippy.js';
import { Console } from "console";

declare let Dropzone: any;
declare let Cropper: any;

@ModuleName("MainGiftCards")
export class MainGiftCards implements AxInit {
    private initData: AxGiftCardsInit;
    private giftCardObserver: IntersectionObserver;
    private dz: Dropzone;
    private crop: Cropper;
    private addURL: string;
    private PostURL: string;
    public selectedGIftCardTypeId: number = 0;
    private imageOrientation: any = -1;
    private instanceInfo;
    public giftCardData: any = {
        amount: 0,
        cropperModel: {
            x: null,
            y: null,
            width: null,
            height: null,
            rotate: null,
            scaleX: null,
            scaleY: null,
            Resolution: null,
            orientation: null
        }
    };
    constructor(
        private _I18nHelper = new I18nHelper(),
        private _ProgressBarGiftCards = new ProgressBar(),
        private _AxProgressBar = new AxProgressBar(),
        private _AxInputWithCounter = new AxCounterWithInput(),
        private _AxLimestone = new AxLimeStone(),
        private amount: number,
        protected _RequestHelper = new RequestHelper()
    ) {
    }

    AxInit(init: AxGiftCardsInit): void {
        this.initData = init;

        this.instanceInfo = tippy(document.querySelector('#UploadInfo'), {
            content: this._I18nHelper.GetTranslation(Translations.MaximumFileSize).replace("{{size}}", "7").replace("{{file}}", "Image") + " " + this._I18nHelper.GetTranslation(Translations.AcceptableFilesExtention).replace("{{filesExtention}}", ".jpeg, .jpg, .png"),
            placement: 'left',
            interactive: true,
            trigger: 'manual',
            theme: 'material',

        });

        let that = this;
        let steps = this._ProgressBarGiftCards.GetGiftCardSteps();
        if (this.initData.ProgressBarActiveStep == ProgressBarActiveStepEnum.AmountDesign) {
            steps[0].type = "active";
        } else {
            steps[1].type = "active";
        }
        this.addURL = this.initData.addURL;
        this.PostURL = this.initData.PostURL;

        this._AxProgressBar.Init({
            target: '.GiftCards__progressbar',
            steps: steps
        });
        this._AxInputWithCounter.Init({
            target: '.GiftCards__Amount',
            incrementValue: this.initData.steps,
            minValue: 0,
            maxValue: this.initData.upperLimit,
            text: this.initData.currency,
            onChange: x => {
                this.InputValidation();
            }
        });

        this.InitializeGlider();

        this.AttachOnClickOnGiftCards();
        this.AttachChipsClicks();

        $('#GiftCards__UseTemplatesOption').click(x => {
            this.instanceInfo.destroy();
            this.ChangeTemplates('#GiftCards__UseTemplatesOption');
        });
        $('#GiftCards__UploadTemplatesOption').click(x => {
            this.instanceInfo.show();
            this.ChangeTemplates('#GiftCards__UploadTemplatesOption');
        });

        $('#BtnContinue').click(x => {
            this._AxLimestone.LockButton($('#BtnContinue')[0]);
            this.PersonalizeGiftCard();
        });

        $('#BtnContinueMob').click(x => {
            this._AxLimestone.LockButton($('#BtnContinueMob')[0]);
            this.PersonalizeGiftCard();
        });

        $('#GiftCards__UploadImgTest').click(x => {
            this.PersonalizeGiftCardSave();
        });

        $('#GiftCards__Cropper__Save').click(x => {
            this.PrepareGiftCardUpload();
        });

        $('#GiftCards__Cropper__Cancel').click(x => {
            this.CancelCroperEdit();
            this.PrepareDropzone();
        });

        $('#GiftCard_templateImgEdit').click(x => {
            this.CropperEditExistingImg();
        });
        $('#GiftCard_templateImgDelete').click(x => {
            this.instanceInfo.show();
            this.CropperDeleteExistingImg();
            this.PrepareDropzone();

        });

        this.PrepareDropzone();

        $('.admin_assets__assetUpload_modal').on('hide.bs.modal', function () {
            that.dz.removeAllFiles();
        }); $('.GiftCard__cropper').on('hide.bs.modal', function () {
            event.preventDefault();
        });

        this.AttachGiftCardsEmptyActions();

        $('.admin_assets__details_close').click(e => {
            this.CloseDetails();
        });

        $('#GiftCards__UploadImg').click(e => {
            this.UploadImage();
        });

        document.getElementById('cropperImageGiftCard').addEventListener('load', () => {
            $('.GiftCard__cropper').modal('show');
        });

        $('.GiftCard__cropper').on('shown.bs.modal', () => {
            this.AttachCropper();
        })
        this.FixMobileScroll();
        this.ToogleMobContinueBtn();
    }

    FixMobileScroll() {
        $(document).ready(() => {
            if (window.screen.width < 992) {
                if (!$('body').hasClass('ax-body--top')) {
                    $('body').addClass('ax-body--top');
                    window.addEventListener("scroll", x => { this.CheckMobileBtn() });
                }
            }
        });
    }

    ToogleMobContinueBtn() {
        $(document).ready(() => {
            this.giftCardObserver = new IntersectionObserver(
                ([e]) => {
                    if (window.screen.width < 992) {
                        //without this scroll does not scroll as it should
                        if (!$('body').hasClass('ax-body--top')) {
                            $('body').addClass('ax-body--top');
                        }
                        window.addEventListener("scroll", x => { this.CheckMobileBtn() });
                    }
                },
                { threshold: 1 }
            );
            this.giftCardObserver.observe(document.querySelector('.GiftCards__progressbar'));
        });
    }

    CheckMobileBtn() {
        let scrollY = window.scrollY;
        let screenHeight = window.screen.height;
        let heightToShowBtn = $(".ax-body").height() - screenHeight;
        if ((scrollY) >= heightToShowBtn && window.screen.width < 992) {
            if (!$('.prod_selection__summary').hasClass('d-flex')) {
                $('.prod_selection__summary').addClass('d-flex');
                $('.prod_selection__summary').removeClass('d-none');
            }
        } else {
            $('.prod_selection__summary').removeClass('d-flex');
            $('.prod_selection__summary').addClass('d-none');
        }
    }


    InputValidation() {
        if ($('#GiftCards__amount__value').val() == 0) {
            $('#BtnContinue').attr('disabled', 'disabled');
            return;
        }
        const awaitTimeout = delay =>
            new Promise(resolve => setTimeout(resolve, delay));
        awaitTimeout(200).then(() => {
            let oldValue = $('#GiftCards__amount__value').val() as string;
            let depositStepSize = this.initData.depositStepSize !== 0 ? this.initData.depositStepSize : 1;
            let modulo = parseInt(oldValue) % depositStepSize;
            if (modulo !== 0) {
                $('.giftcards__amount-invalid').removeClass('d-none');
                $('#BtnContinue').prop('disabled', true);
            } else {
                $('.giftcards__amount-invalid').addClass('d-none');
                $('#BtnContinue').prop('disabled', false);
            }
            this.CheckChipsButtons();
        });
    }

    InitializeGlider() {
        let numberOfTemplates = $('.glide__slides').children().length;

        if (numberOfTemplates > 0) {
            let defaultNumberOfTemplates: number = 4;
            let glide = new Glide('.glide', {
                type: 'slider',
                startAt: 0,
                perView: defaultNumberOfTemplates,
                rewind: false,
                bound: true,
                animationDuration: 300,
                slideWidth: 300,
                //focusAt: 'center',
                breakpoints: {
                    800: {
                        perView: 2
                    },
                    400: {
                        perView: 1
                    }
                },
                classes: {
                    disabledArrow: 'glide__arrow--disabled'
                },
            });

            glide.on('run.before', e => {
                //e.steps = e.direction === '>' ? -glide.settings.perView : glide.settings.perView
            })
            glide.mount({
                'DisableControls': this.updateGlideFunc,
                //'setGlideSize': this.setGlideSize
            });
        }
    }

    private updateGlideFunc: ComponentFunction = (glide: Glide.Static, Components: any, Events: any) => {

        const PREV_CONTROL_SELECTOR = "[data-glide-dir='<']";
        const NEXT_CONTROL_SELECTOR = "[data-glide-dir='>']";
        const component = {
            buildAfter() {
                this.prevBtn = Components.Html.root.querySelector(PREV_CONTROL_SELECTOR);
                this.nextBtn = Components.Html.root.querySelector(NEXT_CONTROL_SELECTOR);
            },
            handleDisable() {
                const perView = glide.settings.perView;
                const slidesCount = Components.Html.slides.length;

                this.prevBtn.disabled = (glide.index <= 0);
                this.nextBtn.disabled = (glide.index >= slidesCount - perView);
            },
            mount() {
            }
        };

        Events.on("build.after", function () {
            component.buildAfter();
            component.handleDisable();
        });
        Events.on("run.after", function () {
            component.handleDisable();
        });
        return component;
    }

    AttachOnClickOnGiftCards() {
        let giftCardsCount = $('.GiftCardAmount').length;
        for (let max = giftCardsCount, i = 0; i < max; i++) {
            let elemm: HTMLElement = $('.GiftCardAmount')[i];
            let amount = elemm.getElementsByTagName('input')[0].value.toString();

            $(elemm).click(x => {
                this.selectAmount(amount);
                $(elemm).toggleClass('ax-chip--active');
            });
        }
    }

    AttachChipsClicks() {
        $(".ax-chip").click(e => {
            let newAmount = $(e.target).html().split(" ");
            $(".ax-chip").removeClass("ax-chip--active");
            $(e.target).addClass("ax-chip--active");
            this.selectAmount(newAmount[0]);
        });
    }

    CheckChipsButtons() {
        $(".ax-chip").removeClass("ax-chip--active");
        let giftCardValue = $("#GiftCards__amount__value").val();
        $(".ax-chip").each(function (item) {
            let chipCardValue = $(this).text().split(" ")[0];
            if (chipCardValue == giftCardValue) {
                $(this).addClass("ax-chip--active");
            }
        });
    }

    selectAmount(value: string) {
        this._AxInputWithCounter.changeAmount(parseInt(value));
    }

    CancelCroperEdit() {
        if (this.giftCardData.cropperModel.x === null) {
            $('.GiftCard__cropper').modal('hide');
            $('#GiftCard_uploadedTemplateImg').toggleClass('d-none');
            this.CropperDeleteExistingImg();
            this.PrepareDropzone();
        } else {
            $('.GiftCard__cropper').modal('hide');
            $('#GiftCard_uploadedTemplateImg').toggleClass('d-none');
        }
    }

    CropperDeleteExistingImg() {
        $('#GiftCard_uploadedTemplateImg').toggleClass('d-none');
        $('#GiftCard__TemplateUploadedImg').children('img').remove();
        this.giftCardData = {
            amount: 0,
            cropperModel: {
                x: null,
                y: null,
                width: null,
                height: null,
                rotate: null,
                scaleX: null,
                scaleY: null,
                Resolution: null,
                orientation: null
            }
        };
        $("#GiftCardCropperModel").val(`${JSON.stringify(this.giftCardData.cropperModel)}`);
        this.DestroyCropper();
        this.DestroyDropzone();
        $('.GiftCard__dZ').show();
    }

    CropperEditExistingImg() {
        $('#GiftCard_uploadedTemplateImg').toggleClass('d-none');
        $('.GiftCard__cropper').modal('show');
    }

    PrepareGiftCardUpload() {
        console.log('PrepareGiftCardUpload');
        $('#GiftCard__TemplateUploadedImg').addClass('w-h-100');
        $('#GiftCard__TemplateUploadedImg').children('img').remove();
        $('#GiftCard__TemplateUploadedImg').append("<img src class='w-100'/>");
        $('#GiftCard__TemplateUploadedImg').children('img').attr('src', this.crop.getCroppedCanvas().toDataURL("image/png"));
        $('.GiftCard__cropper').modal('hide');
        $('#GiftCard_uploadedTemplateImg').toggleClass('d-none');
        $("#GiftCardAmount").val($("#GiftCards__amount__value").val().toString());
        let cropData = this.crop.getData();


        this.giftCardData.cropperModel.x = Math.floor(cropData?.x);
        this.giftCardData.cropperModel.y = Math.floor(cropData?.y);
        this.giftCardData.cropperModel.width = Math.floor(cropData?.width);
        this.giftCardData.cropperModel.height = Math.floor(cropData?.height);
        this.giftCardData.cropperModel.rotate = Math.floor(cropData?.rotate);
        this.giftCardData.cropperModel.scaleX = Math.floor(cropData?.scaleX);
        this.giftCardData.cropperModel.scaleY = Math.floor(cropData?.scaleY);
        this.giftCardData.cropperModel.Resolution = null;
        this.giftCardData.cropperModel.orientation = null;

        $("#GiftCardCropperModel").val(`${JSON.stringify(this.giftCardData.cropperModel)}`);
    }

    AttachGiftCardsEmptyActions() {
        let count: number = $('.glide__slides').children().length;
        if (count === 1) {
            this.ToogleGiftCardsEmpty(1);
        } else {
            for (let i = 1; i < count + 1; i++) {
                let container = '#GiftCards__GiftCardEmpty' + i;
                $(container).click(e => {
                    this.ToogleGiftCardsEmpty(i);
                });
            }
        }
    }

    ToogleGiftCardsEmpty(id: any) {
        if (this.selectedGIftCardTypeId != 0 && this.selectedGIftCardTypeId != id) {
            this.ToogleGiftCardsEmpty(this.selectedGIftCardTypeId);
        }

        if (this.selectedGIftCardTypeId == id) {
            this.selectedGIftCardTypeId = 0;
        } else {
            this.selectedGIftCardTypeId = id;
        }
        let container = '#GiftCards__GiftCardEmpty' + id;
        let checkid = '#GiftCards__Check__' + id;
        $(container).toggleClass('ax-outline-primary');
        $(checkid).toggleClass('d-none');
    }

    ChangeTemplates(selectedElementId: string) {
        let isSelected = this.IsTemplateOptionSelected(selectedElementId);

        if (!isSelected) {
            $('#GiftCards__UploadTemplatesOption').toggleClass("active");
            $('#GiftCards__UseTemplatesOption').toggleClass("active");
            $('#GiftCards__UseTemplates').toggleClass("d-none");
            $('#GiftCards__UploadTemplates').toggleClass("d-none");
        }
    }

    IsTemplateOptionSelected(optionId: string): boolean {
        let isSelected: boolean = false;
        if ($(optionId).hasClass(" ax-border-gray-900")) {
            isSelected = true;
        }
        return isSelected;
    }
    EnableBtnContinue() {
        this._AxLimestone.UnlockButton($('#BtnContinue')[0]);
    }

    PersonalizeGiftCard() {
        if ($('#GiftCards__UseTemplates').length !== 0 && !$('#GiftCards__UseTemplates').hasClass('d-none')) {
            if (this.selectedGIftCardTypeId == 0) {
                Swal.fire({
                    title: this._I18nHelper.GetTranslation(Translations.Error),
                    icon: 'warning',
                    html: this._I18nHelper.GetTranslation(Translations.PleaseSelectGiftCardTemplate)
                }).then(() => {
                    this._AxLimestone.UnlockButton($('#BtnContinue')[0]);
                    this._AxLimestone.UnlockButton($('#BtnContinueMob')[0]);
                });
            } else {
                this.Personalize("");
            }
        } else {
            if (!$('#GiftCard_uploadedTemplateImg').hasClass('d-none')) {
                this.dz.processQueue();
            } else {
                Swal.fire({
                    title: this._I18nHelper.GetTranslation(Translations.Error),
                    icon: 'warning',
                    html: this._I18nHelper.GetTranslation(Translations.PleaseSelectGiftCardTemplate)
                }).then(() => {
                    this._AxLimestone.UnlockButton($('#BtnContinue')[0]);
                    this._AxLimestone.UnlockButton($('#BtnContinueMob')[0]);
                });
            }
        }
    }


    PersonalizeGiftCardSave() {
        let url = $("#GiftCards__IndexContinue").val().toString();
        let amount = $("#GiftCards__amount__value").val().toString();
        url = url.replace('_amount', amount);
        url = url.replace('_cropperModel', JSON.stringify(this.crop.getData()));
        alert(url);
    }

    populateSubmitDropzoneForm(formData) {
        formData.append("amount", this.amount);
        formData.append("x", this.giftCardData.cropperModel.x.toString());
        formData.append("y", this.giftCardData.cropperModel.y.toString());
        formData.append("width", this.giftCardData.cropperModel.width.toString());
        formData.append("height", this.giftCardData.cropperModel.height.toString());
        formData.append("rotate", this.giftCardData.cropperModel.rotate.toString());
        formData.append("scaleX", this.giftCardData.cropperModel.scaleX.toString());
        formData.append("scaleY", this.giftCardData.cropperModel.scaleY.toString());
        formData.append("Resolution", null);
        formData.append("orientation", this.imageOrientation);
    }

    PrepareDropzone() {
        let that = this;
        this.DestroyDropzone();
        this.DestroyCropper();

        $('.GiftCard__dZ').dropzone({
            url: this.addURL,
            autoProcessQueue: false,
            maxFiles: 1,
            maxFilesize: 7,
            acceptedFiles: ".jpeg,.jpg,.png",
            sending: function (file, xhr, formData) {
                formData.append("amount", $("#GiftCardAmount").val().toString());
                formData.append("x", (that.giftCardData.cropperModel === undefined) ? null : `${that.giftCardData.cropperModel.x}`);
                formData.append("y", that.giftCardData.cropperModel?.y.toString());
                formData.append("width", that.giftCardData.cropperModel?.width.toString());
                formData.append("height", that.giftCardData.cropperModel?.height.toString());
                formData.append("rotate", that.giftCardData.cropperModel?.rotate.toString());
                formData.append("scaleX", that.giftCardData.cropperModel?.scaleX.toString());
                formData.append("scaleY", that.giftCardData.cropperModel?.scaleY.toString());
                formData.append("Resolution", null);
                formData.append("orientation", that.imageOrientation);
            },
            accept: function (file, done) {
                this.dz = this;
                let filework: any;
                filework = file;
                done();
                that.showCropperUploadGiftCard(filework);
            },
            success: (file, resp) => {
                if (resp.data != "") {
                    this.Personalize(resp.data);
                }

            },
            error: (errFile) => {
                let filesize = Math.round(100 * errFile.size / Math.pow(1024, 2)) / 100;
                let acceptedFiles = ["jpeg", "jpg", "png"]
                if (filesize > 7) {
                    const size_instance = tippy(document.querySelector('.GiftCard__dZ'), {
                        content: this._I18nHelper.GetTranslation(Translations.DrpZneFileTooBig).replace("{{filesize}}", filesize.toString()).replace("{{maxFilesize}}", "7"),
                        placement: 'left',
                        trigger: 'manual',
                        interactive: true,
                        theme: 'material',

                    });
                    size_instance.show();
                }
                else if (!acceptedFiles.includes(errFile.name.split(".").pop())) {
                    const type_instance = tippy(document.querySelector('.GiftCard__dZ'), {
                        content: this._I18nHelper.GetTranslation(Translations.AcceptableFilesExtention).replace("{{filesExtention}}", ".jpeg, .jpg, .png"),
                        allowHTML: true,
                        placement: 'right',
                        trigger: 'manual',
                        interactive: true,
                        theme: 'material',

                    });
                    type_instance.show();
                }

                this.PrepareDropzone();
            }

        });
        this.dz = Dropzone.instances[0];
        $(".dz-default.dz-message").toggleClass('d-none');
    }

    Personalize(imageName: string) {
        let url = $("#GiftCards__IndexContinue").val().toString();
        let amount = this._AxInputWithCounter.getAmount();
        url = url.replace('_amount', amount);

        url = url.replace('_imageName', imageName);
        url = url.replace('_selectedTemplate', this.selectedGIftCardTypeId.toString());

        let requestObj = {
            retailItemNr: this.initData.retailItemNr,
            amount: amount,
            imageName: imageName,
            selectedTemplate: this.selectedGIftCardTypeId
        };
        this._RequestHelper.postToUrl(this.PostURL, requestObj, {});
    }

    showCropperUploadGiftCard(fileToWorkWith) {
        $('.GiftCard__dZ').hide();
        let that = this;
        EXIF.getData(fileToWorkWith, function () {
            try {
                let allTags = EXIF.getAllTags(this);
                //console.log(allTags);
                if ("Orientation" in allTags) {
                    that.imageOrientation = EXIF.getTag(this, "Orientation");
                }
            }
            catch (e) {
                that.imageOrientation = -2;
                console.log("Error get Orientation from EXIF data: " + e.message);
            }
        });
        $('#cropperImageGiftCard').attr('src', URL.createObjectURL(this.dz.files[0]));
    }

    AttachCropper() {
        if (this.crop) return;
        let img: HTMLElement = document.getElementById('cropperImageGiftCard');

        this.crop = new Cropper(img, {
            aspectRatio: 1200 / 675,
            viewMode: 2,
            zoomable: false,
            cropBoxMovable: true,
            dragMode: 'none',
            scalable: false,
            crop(event) {
            }
        });
    }

    DestroyDropzone() {
        if (this.dz != null) {
            this.dz.destroy();
        }
    }

    DestroyCropper() {
        if (this.crop) {
            this.crop.destroy();
            $('#cropperImage').attr('src', '');
            $('.admin_assets__assetUpload_dZ').show();
            this.crop = null;
        }
    }
    ClearCropper() {
        if (this.crop) {
            this.crop.clear();
        }
    }

    UploadImage() {
        this.dz.processQueue();
    }

    AssetDetails(asset: Asset) {
        $('.admin_assets__wrapper').addClass('d-none');
        $('.admin_assets__details_Title').html(asset.FileName);
        $('.admin_assets__details_UID').html(asset.UID);
        $('.admin_assets__details_FileSize').html(asset.FileSize);
        $('.admin_assets__details_Resolution').html(asset.Resolution);
        $('.admin_assets__details_Type').html(asset.MimeType);
        $('.admin_assets__details_Created').html(asset.Created);
        $('.admin_assets__details_Updated').html(asset.Created);

        $('.admin_assets__details_Link').html(asset.Link).attr('href', asset.Link);
        $('.admin_assets__details_imageHolder img').attr('src', asset.Link);
        //this.currentAssetID = asset.AssetID;

        $('.admin_assets__overlay').removeClass('d-none');
    }

    CloseDetails() {
        $('.admin_assets__wrapper').removeClass('d-none');
        $('.admin_assets__overlay').addClass('d-none');
        this.DestroyCropper();
        //this.currentAssetID = 0;
    }
}

export interface AxGiftCardsInit {
    ProgressBarActiveStep: ProgressBarActiveStepEnum;
    addURL: string;
    PostURL: string;
    getTemplateURL: string;
    CartURL: string;
    steps: number;
    upperLimit: number;
    retailItemNr: number;
    currency: string;
    depositStepSize: number;
}

export enum ProgressBarActiveStepEnum {
    AmountDesign = 0,
    Personalize = 1
}
